<template>
    <div class="sw-flex sw-form-section">
        <div v-if="edit">
            <i @click="$emit('delete')" class="fa fa-trash"></i>
            <i @click="$emit('edit')" class="fa fa-pen"></i>
        </div>
        <div class="sw-flex-grow">
            <div class="sw-question sw-flex sw-container">
                {{ title }}
            </div>
            <div v-if="windowWidth>=768"
                 class="sw-scala sw-container sw-flex-center sw-flex">
                <div
                    class="sw-mb-2 sw-mr-2 sw-mt-2 flex-shrink-0 sw-index font-semibold scala-question left-legend">
                    {{leftLegend}}
                </div>
                <div class="sw-flex sw-mr-2 sw-flex-grow sw-justify-between sw-mb-2 sw-mt-2">
                    <div v-for="(index) in parseInt(scala)" :id="`${id}_option_${index}`" class="sw-flex sw-align-center">
                        <input :value="index" @input="$emit('input:checked', {id: id, value: $event.target.value})" class="sw-radio form-radio sw-mr-1"
                               type="radio" :name="id"/>
                        <div class="sw-index"> {{ index }}</div>
                    </div>
                </div>
                <div class="sw-mb-2 sw-ml-2 sw-mt-2 flex-shrink-0 sw-index font-semibold scala-question right-legend">{{rightLegend }}
                </div>
            </div>
            <div v-else class="sw-scala sw-container sw-flex-center sw-block">
                <div class="sw-mb-2 sw-mr-2 sw-mt-2 flex-shrink-0 sw-index font-semibold scala-question left-legend sw-text-left">
                    {{ leftLegend }}
                </div>
                <div class="sw-flex sw-mr-2 sw-flex-grow sw-justify-between sw-mb-2 sw-mt-2">
                    <div v-for="(index) in parseInt(scala)" :id="`${id}_option_${index}`" class="sw-flex sw-align-center">
                        <input :value="index" @input="$emit('input:checked',{id: id, value: $event.target.value})" class="sw-radio form-radio sw-mr-1"
                               type="radio" :name="id"/>
                        <div class="sw-index"> {{ index }}</div>
                    </div>
                </div>
                <div class="sw-mb-2 sw-ml-2 sw-mt-2 flex-shrink-0 sw-index font-semibold scala-question right-legend sw-text-right">
                    {{ rightLegend }}
                </div>
            </div>
            <div v-if="dontKnowLegend" class="sw-scala sw-container sw-flex-center sw-flex">
                <div class="sw-mb-2 sw-mr-2 sw-mt-2 flex-shrink-0 sw-index font-semibold scala-question left-legend">
                    {{dontKnowLegend}}
                </div>
                <div class="sw-flex sw-mr-2 sw-flex-grow sw-justify-between sw-mb-2 sw-mt-2">
                    <div id="97a5a02c-6a07-41ed-81e0-8cb7b9464e1c_option_1" class="sw-flex">
                        <input :value="1" @input="$emit('input:checked',{id: id, value: $event.target.value})" class="sw-radio form-radio sw-mr-1"
                               type="radio" :name="id"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Input from "@/Pages/Forms/Partials/Input.vue";

export default {
    name: "ScalaQuestion",
    components: {Input},
    props: {
        edit: Boolean,
        id: {
            type: [String, Number],
            required: true
        },
        title: {
            type: String,
            default: 'Titel'
        },
        scala: {
            type: [String, Number],
            default: 5
        },
        leftLegend: {
            type: String,
            default: 'Von',
        },
        rightLegend: {
            type: String,
            default: 'Bis',
        },
        dontKnowLegend: {
            type: String,
            default: '',
        },
        is_knockout_question: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return{
            windowWidth:window.innerWidth
        }
    },
    mounted() {
        window.onresize =()=>{
            this.windowWidth = window.innerWidth;
        };
    },
    methods:{
    }
}
</script>

<style scoped lang="sass">
</style>
